import Navigation from './Navigation';
import PageContainer from './PageContainer';
import { Outlet } from 'react-router-dom';
import AlertPopup from './AlertPopup';
import { useNotifications } from '../context/NotificationContext';

function Layout() {
  const { latestAlert, setLatestAlert } = useNotifications();

  return (
    <div className="app-shell">
      <Navigation />
      <PageContainer>
        <Outlet />
      </PageContainer>
      <AlertPopup
        notification={latestAlert}
        onClose={() => setLatestAlert(null)}
      />
    </div>
  );
}

export default Layout;

